<template>
  <v-dialog v-model="active" max-width="400px" persistent class="l-dialog">
    <template v-slot:activator="{ on }">
      <slot name="activator" v-bind="{ on: on }" />
    </template>
    <v-card class="l-card" height="100%">
      <v-container fluid class="background pa-0 l-card__title__container">
        <v-row align="center" class="ma-0 l-card__title__row">
          <v-col cols="12" class="pa-4">
            <span class="l-card__title__text">Histórico de alterações</span>
          </v-col>
          <v-btn absolute right top icon x-small color="#E5E8E7" @click="active = !active">
            <v-icon>fa fa-times</v-icon>
          </v-btn>
        </v-row>
      </v-container>
      <v-container fluid class="pa-0 ma-0 l-card__content__container_c">
        <v-row
          align="center"
          class="ma-0 l-card__filter__row pl-5"
          md-gutter
          v-for="status in listHistoryStats"
          :key="status.idProgramacaoAbateStatus"
        >
          <v-col cols="2">
            <v-icon
              v-if="status.cdStatusProgramacaoAbate != 7"
              class="icon-stats"
            >fas fa-check-circle</v-icon>
            <v-icon v-else class="icon-stats-exclamation">fas fa-exclamation-circle</v-icon>
          </v-col>
          <v-col cols="10">
            <span
              class="text-date-history text-capitalize"
            >{{status.dhStatus | formatWeekDay() }} - {{status.dhStatus | formatDay()}}</span>
            <br />
            <span
              class="text-stats-history"
            >{{status.cdStatusProgramacaoAbate | formatStatusDisplayAPI()}}</span>
            <br />
            <span class="text-user-history">Por {{status.nmUser}}</span>
          </v-col>
          <v-col cols="12" class="ma-0 pa-0">
            <v-divider></v-divider>
          </v-col>
        </v-row>
      </v-container>
      <v-container
        v-if="cdStatusProgramacao <= 1"
        fluid
        class="pa-0 ma-0 l-card__content__container_c"
      >
        <v-row align="center" class="ma-0 l-card__filter__row pl-5" md-gutter>
          <v-col cols="2">
            <v-icon class="icon-stats-not-informed">far fa-circle</v-icon>
          </v-col>
          <v-col cols="10">
            <span class="text-stats-history">{{2 | formatStatusDisplayAPI()}}</span>
          </v-col>
          <v-col cols="12" class="ma-0 pa-0">
            <v-divider></v-divider>
          </v-col>
        </v-row>
      </v-container>
      <v-container
        v-if="cdStatusProgramacao <= 2"
        fluid
        class="pa-0 ma-0 l-card__content__container_c"
      >
        <v-row align="center" class="ma-0 l-card__filter__row pl-5" md-gutter>
          <v-col cols="2">
            <v-icon class="icon-stats-not-informed">far fa-circle</v-icon>
          </v-col>
          <v-col cols="10">
            <span class="text-stats-history">{{3 | formatStatusDisplayAPI()}}</span>
          </v-col>
          <v-col cols="12" class="ma-0 pa-0">
            <v-divider></v-divider>
          </v-col>
        </v-row>
      </v-container>
      <v-container
        v-if="cdStatusProgramacao <= 3"
        fluid
        class="pa-0 ma-0 l-card__content__container_c"
      >
        <v-row align="center" class="ma-0 l-card__filter__row pl-5" md-gutter>
          <v-col cols="2">
            <v-icon class="icon-stats-not-informed">far fa-circle</v-icon>
          </v-col>
          <v-col cols="10">
            <span class="text-stats-history">{{4 | formatStatusDisplayAPI()}}</span>
          </v-col>
          <v-col cols="12" class="ma-0 pa-0">
            <v-divider></v-divider>
          </v-col>
        </v-row>
      </v-container>
      <v-container
        v-if="cdStatusProgramacao <= 4"
        fluid
        class="pa-0 ma-0 l-card__content__container_c"
      >
        <v-row align="center" class="ma-0 l-card__filter__row pl-5" md-gutter>
          <v-col cols="2">
            <v-icon class="icon-stats-not-informed">fas fa-circle</v-icon>
          </v-col>
          <v-col cols="10">
            <span class="text-stats-history">{{5 | formatStatusDisplayAPI()}}</span>
          </v-col>
          <v-col cols="12" class="ma-0 pa-0">
            <v-divider></v-divider>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";

const SLAUGHTER_SCHEDULE_STATUS_API = {
  1: "Programação criada",
  2: "Demanda definida",
  3: "Lotes alocados",
  4: "Programação",
  5: "Carregamento",
  6: "Programação cancelada",
  7: "Alteração de lotes",
};

export default {
  name: "DialogHistoryStats",
  props: {
    listHistoryStats: {
      type: Array,
    },
    cdStatusProgramacao: {
      type: Number,
    },
  },
  data: () => ({
    active: false,
  }),
  filters: {
    formatStatusDisplayAPI(value) {
      const status = SLAUGHTER_SCHEDULE_STATUS_API[value];
      if (!status) return "";
      return status;
    },
    formatWeekDay(value) {
      let m = moment(value);
      let text = m.format("dddd");
      return text.substring(0, 3);
    },
    formatDay(value) {
      let m = moment(value);
      return m.format("DD/MM");
    },
  },
};
</script>

<style scoped>
.text-date-history {
  text-align: left;
  font: normal 10px Roboto;
  letter-spacing: 0.4px;
  color: #10303d;
  text-transform: uppercase;
  opacity: 0.7;
}

.text-stats-history {
  text-align: left;
  font: medium 16px Roboto;
  letter-spacing: 0px;
  color: #10303d;
  opacity: 0.7;
}

.text-user-history {
  text-align: left;
  font: normal 12px Roboto;
  letter-spacing: 0px;
  color: #10303d;
  opacity: 0.7;
}

.icon-stats {
  color: #0ca5a2 !important;
  opacity: 1 !important;
}

.icon-stats-exclamation {
  color: #f5b800 !important;
  opacity: 1 !important;
}

.icon-stats-not-informed {
  color: #7b9596 !important;
  opacity: 1 !important;
}
</style>